<script setup lang="ts">
    import AnonymizationManager from '@cwd/Account/AnonymizationManager.vue';
    import MergeContactManager from '@cwd/Account/MergeContactManager.vue';
    import Tabs, { tab } from '@shared/components/Tabs.vue';
    import { ref } from 'vue';

    const mergeTabActivated = ref(false);
</script>

<template>
    <h1 class="h2 m-lg-b">{{ $Resources.DataManagementHeading }}</h1>

    <tabs>
        <tab :title="$Resources.DataManagementTabInactiveContactsLabel">
            <anonymization-manager></anonymization-manager>
        </tab>

        <tab :title="$Resources.DataManagementTabMergeContactsLabel" @tabClick="mergeTabActivated = true">
            <merge-contact-manager v-if="mergeTabActivated"></merge-contact-manager>
        </tab>
    </tabs>
</template>
